import { render, staticRenderFns } from "./AtomEditionSectionNavigationMenu.vue?vue&type=template&id=ece2bd5a&"
import script from "./AtomEditionSectionNavigationMenu.vue?vue&type=script&lang=js&"
export * from "./AtomEditionSectionNavigationMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports